module.exports = __webpack_public_path__ + "img/tour-25.6a9e8234.png";